<script lang="ts">
  import { appEventDispatcher } from '../../../lib/events/Provider';
  import { setAppDispatcherContext } from './context';

  export let value = appEventDispatcher;
  setAppDispatcherContext(value);
</script>

<slot />
